module.exports = __webpack_public_path__ + "static/media/wadi-rum.c1ebb35d.jpg";